/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationDto } from './NotificationDto';
import {
    NotificationDtoFromJSON,
    NotificationDtoFromJSONTyped,
    NotificationDtoToJSON,
    NotificationDtoToJSONTyped,
} from './NotificationDto';

/**
 * 
 * @export
 * @interface PagedNotificationDto
 */
export interface PagedNotificationDto {
    /**
     * 
     * @type {Array<NotificationDto>}
     * @memberof PagedNotificationDto
     */
    content: Array<NotificationDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationDto
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationDto
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationDto
     */
    numberOfElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedNotificationDto
     */
    last: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationDto
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedNotificationDto
     */
    first: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagedNotificationDto
     */
    totalElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagedNotificationDto
     */
    empty: boolean;
}

/**
 * Check if a given object implements the PagedNotificationDto interface.
 */
export function instanceOfPagedNotificationDto(value: object): value is PagedNotificationDto {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('numberOfElements' in value) || value['numberOfElements'] === undefined) return false;
    if (!('last' in value) || value['last'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('first' in value) || value['first'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('empty' in value) || value['empty'] === undefined) return false;
    return true;
}

export function PagedNotificationDtoFromJSON(json: any): PagedNotificationDto {
    return PagedNotificationDtoFromJSONTyped(json, false);
}

export function PagedNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedNotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(NotificationDtoFromJSON)),
        'number': json['number'],
        'size': json['size'],
        'numberOfElements': json['numberOfElements'],
        'last': json['last'],
        'totalPages': json['totalPages'],
        'first': json['first'],
        'totalElements': json['totalElements'],
        'empty': json['empty'],
    };
}

export function PagedNotificationDtoToJSON(json: any): PagedNotificationDto {
    return PagedNotificationDtoToJSONTyped(json, false);
}

export function PagedNotificationDtoToJSONTyped(value?: PagedNotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(NotificationDtoToJSON)),
        'number': value['number'],
        'size': value['size'],
        'numberOfElements': value['numberOfElements'],
        'last': value['last'],
        'totalPages': value['totalPages'],
        'first': value['first'],
        'totalElements': value['totalElements'],
        'empty': value['empty'],
    };
}

